import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {Subscription} from "rxjs/Subscription";
import {GlobalProvider} from "../../providers/global/global";
import {ContactService} from "../../store/contact/contact.service";
import {AuditService} from "../../store/audit/audit.service";
import {ContactEntity} from "../../store/contact/contact.entity";
import {AuditEntity} from "../../store/audit/audit.entity";

/**
 * Generated class for the PruefungKundePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pruefung-kunde',
  templateUrl: 'pruefung-kunde.html',
})
export class PruefungKundePage {

  public customer: ContactEntity;
  public customers: Array<ContactEntity> = [];
  public pruefung: AuditEntity;

  private _pruefungId: string;
  private _pruefungSubscription: Subscription;
  private _customerSubscription: Subscription;
  private _customersSubscription: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public contactService: ContactService,
              public globalProvider: GlobalProvider,
              private auditService: AuditService) {
    console.log('constructor PruefungKundePage');
    this._pruefungId = this.navParams.get('pruefungId');


  }

  ionViewWillEnter() {
    console.log('ionViewDidLoad PruefungKundePage');
    this._pruefungSubscription = this.auditService.getById(this._pruefungId)
      .subscribe((pruefung) => {
        this.pruefung = pruefung;

        this._customerSubscription = this.contactService.getById(this.pruefung.customerId)
          .subscribe((customer) => {
            this.customer = customer;
          })
      })

    this._customersSubscription = this.contactService.getAllByType(1)
      .subscribe((customers) => {
        this.customers = customers;
      })
  }

  ionViewWillLeave(){
    this._customerSubscription.unsubscribe();
    this._pruefungSubscription.unsubscribe();
  }

  public save(data): void {
    if(!this.pruefung)
      return;

    this.pruefung.customerId = data;
    this.auditService.set(this.pruefung, false);
  }

}



// WEBPACK FOOTER //
// ./src/pages/pruefung-kunde/pruefung-kunde.ts